import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, CircularProgress, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import { mapStateToProps } from "../store/helpers/mapState";
import { mapDispatchToProps } from "../store/helpers/mapDispatch";
import { connect } from "react-redux";
import SelectRecipient from './SelectRecipient';
import { errorToast, successToast } from './Notification';

const SubmitTaskReportDialog = ({
    open,
    onClose,
    onSuccess,
    SubmitGeneralForm,
    loggedUser,
    startDate: prefilledStartDate,
    endDate: prefilledEndDate,
    resources,
    processData,
}) => {
    const [loading, setLoading] = useState(false);
    const [reportFile, setReportFile] = useState(null);
    const [name, setName] = useState('');
    const [recipients, setRecipients] = useState([]);
    const [isSelectRecipientOpen, setIsSelectRecipientOpen] = useState(false);

    useEffect(() => {
        if (prefilledStartDate && prefilledEndDate && loggedUser?.Resource?.id) {
            // setName(`Task report from ${prefilledStartDate} to ${prefilledEndDate} by ${loggedUser.Resource.names}`);
        }
    }, [prefilledStartDate, prefilledEndDate, loggedUser]);

    const handleFileChange = (e) => {
        setReportFile(e.target.files[0]);
    };
    
    const handleSubmit = async () => {
        if (!prefilledStartDate || !prefilledEndDate || !name || recipients.length === 0) {
            errorToast("Please fill in all required fields.");
            return;
        }
    
        setLoading(true);
        let formData = new FormData();
        formData.append('body', JSON.stringify({
            name,
            startDate: prefilledStartDate,
            endDate: prefilledEndDate,
            recipients: recipients.map(r => r.id),
        }));
        if (reportFile) {
            formData.append('attachment', reportFile);
        }
        
        try {
            const reportResponse = await SubmitGeneralForm('/api/task/task-report/attchment', formData);

            if (reportResponse.status && reportResponse.data?.reportAttachment?.id) {
                const reportId = reportResponse.data.reportAttachment.id;
    
                const transformedData = processData.map((task) => ({
                    reportId,
                    name: task.name,
                    description: task.description,
                    status: task.status,
                    taskInitiator: task.taskInitiator.names,
                    taskAssignees: task.task_assignees.map((assignee) => assignee.ResourceId),
                    taskSatartDate: task.startDate,
                    taskEndDate: task.endDate,
                    challenge: task.challenge,
                }));
    
                const taskResponse = await SubmitGeneralForm('/api/report/tasks/save-reported-task/', {
                    reportedTasks: transformedData,
                });
    
                if (taskResponse.status) {
                    successToast("Report and tasks saved successfully.");
                    onSuccess();
                    onClose();
                } else {
                    errorToast("Failed to save tasks.");
                }
            } else {
                errorToast("Failed to create report attachment.");
            }
        } catch (error) {
            errorToast("An error occurred while submitting the report.");
        } finally {
            setLoading(false);
        }
    };
    const handleSelectRecipients = (selectedEmployees) => {
        setRecipients(selectedEmployees);
        setIsSelectRecipientOpen(false);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Submit Task Report</DialogTitle>
            <DialogContent>
                <TextField
                    label="Report Name"
                    fullWidth
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    margin="normal"
                // disabled
                />
                <div style={{ display: 'flex', gap: '16px', marginTop: '16px' }}>
                    <TextField
                        label="Start Date"
                        type="date"
                        fullWidth
                        value={prefilledStartDate}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        disabled
                    />
                    <TextField
                        label="End Date"
                        type="date"
                        fullWidth
                        value={prefilledEndDate}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        disabled
                    />
                </div>

                <TextField
                    label="Recipients"
                    fullWidth
                    value={recipients.map(r => r.names).join('\n')}
                    margin="none"
                    onClick={() => setIsSelectRecipientOpen(true)}
                    multiline
                    InputProps={{
                        readOnly: true,
                    }}
                />
                <div style={{ marginTop: '16px', border: '1px dashed #ccc', padding: '16px', textAlign: 'center' }}>
                    <input
                        type="file"
                        accept=".pdf"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        id="upload-file"
                    />
                    <label htmlFor="upload-file" style={{ cursor: 'pointer' }}>
                        <Button component="span">Upload a file (optional)</Button>
                    </label>
                    {reportFile && <p>{reportFile.name}</p>}
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    onClose();
                }} disabled={loading}>Cancel</Button>
                <Button onClick={handleSubmit} disabled={loading || !name || recipients.length === 0}>
                    {loading ? <CircularProgress size={24} /> : 'Submit Report'}
                </Button>
            </DialogActions>
            <SelectRecipient
                open={isSelectRecipientOpen}
                onClose={() => setIsSelectRecipientOpen(false)}
                confirm={handleSelectRecipients}
                selectedEmployees={recipients}
                resources={resources}
                settings={{ backgroundColorPrimary: '#1976d2' }}
            />
        </Dialog>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmitTaskReportDialog);
